import styled from "styled-components";

export const StyledMain = styled.main`
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 12px;

  img {
    width: 300px;
  }

  .big-text {
    padding: 24px 12px;
  }

  h1 {
    font-size: 42px;
  }

  p {
  }
`;
